import React, { useEffect, useState } from "react";
import { Spinner } from "@heroui/react";
import { t } from "i18next";

interface VideoPlayerProps {
  onBack?: () => void;
  startTime?: any;
  play?: boolean;
  token?: string;
  deviceId?: string;
  isSidePanelOpen?: boolean;
}

const LoadingOverlay: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    },600);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="absolute top-0 left-0 w-full flex items-center justify-center z-50 animate-fadeIn" style={{ height: "calc(100% - 20px)", backgroundColor: "#000" }}>
      <div className="flex flex-col items-center gap-3 text-white">
        <Spinner color="white" />
        <p className="text-sm opacity-80">{progress}%</p>
      </div>
    </div>
  );
};

const IframeWithOverlay = ({ src, isSidePanelOpen }: { src: string, isSidePanelOpen?: boolean }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [height, setHeight] = useState(isSidePanelOpen ? '31vh' : '36vh');

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  // Smooth height animation sync
  useEffect(() => {
    setHeight(isSidePanelOpen ? '31vh' : '36vh');
  }, [isSidePanelOpen]);

  return (
    <div
      className="relative w-full transition-all duration-500 ease-in-out border-x border-b rounded-b-md"
      style={{ height, borderColor: "var(--border-light)" }}
    >
      {isLoading && <LoadingOverlay />}
      <iframe
        title="Camera Video Feed"
        src={src}
        width="100%"
        height="100%"
        className="border-none"
        allow="autoplay"
        style={{ visibility: isLoading ? 'hidden' : 'visible' }}
      ></iframe>
      <div className="absolute bottom-0 left-0 w-full h-[20px] animate-fadeIn" style={{ backgroundColor: "var(--bg-surface)" }}></div>
    </div>
  );
};

const CameraVideos: React.FC<VideoPlayerProps> = ({ token, deviceId, isSidePanelOpen }) => {

  const url = `https://vss.howentech.com/vss/apiPage/RealVideo.html?token=${token}&deviceId=${deviceId}&stream=0&wnum=1&panel=0&buffer=2000`;

  

  return (
    <div className="flex py-4 w-full" style={{ backgroundColor: "var(--bg-surface)" }}>
        <div className="w-full px-3 animate-fadeIn">
          <div className="px-3 py-2 text-center text-sm font-semibold border-t border-x rounded-t-md" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)", borderColor: "var(--border-light)" }}>
             {t("camera.cabin_view")}
          </div>
          <IframeWithOverlay src={url + "&chs=1"} isSidePanelOpen={isSidePanelOpen}/>
        </div>
        <div className="w-full px-3 animate-fadeIn">
          <div className="px-3 py-2 text-center text-sm font-semibold border-t border-x rounded-t-md" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)", borderColor: "var(--border-light)" }}>
            {t("camera.front_view")}
          </div>
          <IframeWithOverlay src={url + "&chs=2"} isSidePanelOpen={isSidePanelOpen}/>
        </div>
        <div className="w-full px-3 animate-fadeIn">
          <div className="px-3 py-2 text-center text-sm font-semibold border-t border-x rounded-t-md" style={{ backgroundColor: "var(--bg-base)", color: "var(--text-main)", borderColor: "var(--border-light)" }}>
            {t("camera.rear_view")}
          </div>
          <IframeWithOverlay src={url + "&chs=3"} isSidePanelOpen={isSidePanelOpen}/>
        </div>
    </div>
  );
};

export default CameraVideos;
